export const state = {
  shifts: [],
}

export const getters = {
  shifts: (state) => state.shifts,
}

export const mutations = {
  SET_SHIFTS(state, shifts) {
    state.shifts = shifts
  },
  CLEAR_SHIFTS(state) {
    state.shifts = []
  },
}

export const actions = {
  setShifts({ commit }, shifts) {
    commit('SET_SHIFTS', shifts)
  },
  clearShifts({ commit }) {
    commit('CLEAR_SHIFTS')
  },
}
